import { MDText } from 'i18n-react';

import type { SpecSectionField } from 'Components/SpecSection/SpecSection.types';
import type { VehicleMOT } from 'Pages/vehicles/helpers/vehicle.schema';
import { FALLBACK } from 'Pages/vehicles/schemas/schema.const';
import { formatDate } from 'Utilities/formatters';

import { MotAdvisories } from './MotAdvisories/MotAdvisories';
import motSectionTexts from './MotSection.texts';

const localT = new MDText(motSectionTexts);

export const VEHICLE_MOT_FIELDS: SpecSectionField<VehicleMOT>[] = [
	{
		fieldName: 'motStatus',
		isVisible: () => true,
		label: () => localT.translate('motStatus'),
		value: ({ motStatus }) => localT.translate(`status.${motStatus}`),
	},
	{
		fieldName: 'lastMotDate',
		isVisible: () => true,
		label: () => localT.translate('lastMotDate'),
		value: ({ lastMotDate }) => (lastMotDate ? formatDate(lastMotDate) : FALLBACK),
	},
	{
		fieldName: 'advisories',
		isVisible: () => true,
		label: () => localT.translate('advisories'),
		value: () => <MotAdvisories />,
	},
];
